// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"c02dda2f","453":"75c60c62","540":"d3b89970","591":"5d11c27e","600":"ccf04205","652":"8a882133","667":"3aa8dcdd","695":"f31da7e8","867":"b214877b"}[chunkId] + ".chunk.js";
};